// @flow
import React from 'react';
import ProgressiveButton from '../../common/progressive-button/ProgressiveButtonComponent';
import FormInput from '../../common/form-input/FormInputComponent';

import './AccountDetailsPage.scss';

type Props = {
  account: {
    details: {
      companyName: string,
      isLoading: boolean,
    },
  },
  actions: {
    updateAccountDetails: () => void,
  },
};

class AccountDetailsPageComponent extends React.Component<Props> {
  constructor(props: Props): void {
    super(props);
    this.state = {
      error: false,
    };
  }

  handleSubmit = (): void => {
    if (!this.input.value) {
      this.setState({ error: true });
      return;
    }
    this.props.actions.updateAccountDetails(this.input.value);
  };

  onKeyUp = (): void => {
    if (this.input.value) {
      this.setState({ error: false });
    }
  };

  onInput = (input: { value: string }): void => {
    this.input = input;
  };

  render(): Element {
    if (!this.props.account.details.companyName) {
      return <div />;
    }
    return (
      <div className="account-details-page-component">
        <form
          onSubmit={(e) => {
            e.preventDefault();
          }}
        >
          <label htmlFor="company-name" className="label">
            Company Name
          </label>
          <FormInput
            label="company-name"
            onKeyUp={this.onKeyUp}
            defaultValue={this.props.account.details.companyName}
            isError={this.state.error}
            onInput={this.onInput}
            errorMessage="Please fill in this field."
          />
          <ProgressiveButton
            text="Update"
            onClick={this.handleSubmit}
            loading={this.props.account.details.isLoading}
            success={false}
          />
        </form>
      </div>
    );
  }
}

export default AccountDetailsPageComponent;
